module.exports = __webpack_public_path__ + "static/media/icon_button1.ee5e41e4.svg";